import { useTheme } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { AssetronBannerTypes } from '@assetron/common/constants/constant';
import useDesignTokens from '../../../themes/useDesignTokens';

const useAssetronAlertStyles = (type: AssetronBannerTypes) => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const getBgColor = useCallback(() => {
    if (type === AssetronBannerTypes.SUCCESS) {
      return tokens.colors.bg.success.primary;
    }
    if (type === AssetronBannerTypes.WARNING) {
      return tokens.colors.bg.warning.primary;
    }
    if (type === AssetronBannerTypes.INFO) {
      return tokens.colors.bg.secondary;
    }
    return tokens.colors.bg.error.primary;
  }, [type, tokens]);

  const getBorderColor = useCallback(() => {
    if (type === AssetronBannerTypes.SUCCESS) {
      return tokens.colors.border.success;
    }
    if (type === AssetronBannerTypes.WARNING) {
      return tokens.colors.border.warning;
    }
    if (type === AssetronBannerTypes.INFO) {
      return tokens.colors.border.secondary;
    }
    return tokens.colors.border.error;
  }, [type, tokens]);

  const getTextColor = useCallback(() => {
    if (type === AssetronBannerTypes.SUCCESS) {
      return tokens.colors.text.success.secondary;
    }
    if (type === AssetronBannerTypes.WARNING) {
      return tokens.colors.text.warning.secondary;
    }
    if (type === AssetronBannerTypes.INFO) {
      return tokens.colors.text.primary;
    }
    return tokens.colors.text.error.secondary;
  }, [type, tokens]);

  const getIconColor = useCallback(() => {
    if (type === AssetronBannerTypes.SUCCESS) {
      return tokens.colors.fg.success.primary;
    }
    if (type === AssetronBannerTypes.WARNING) {
      return tokens.colors.fg.warning.primary;
    }
    if (type === AssetronBannerTypes.INFO) {
      return tokens.colors.fg.secondary;
    }
    return tokens.colors.fg.error.primary;
  }, [type, tokens]);

  const styles = useMemo(
    () => ({
      alert: {
        borderRadius: tokens.radius.xs,
        backgroundColor: getBgColor(),
        border: '1px solid',
        borderColor: getBorderColor(),
        padding: theme.sizeGuide.lg,
        gap: theme.sizeGuide.md,
        boxShadow: theme.customShadows.buttonShadowMD,
        '.MuiAlert-icon, .MuiAlert-message': {
          margin: theme.sizeGuide.none,
          padding: theme.sizeGuide.none,
        },
      },
      alertIcon: {
        alignContent: 'center',
        color: getIconColor(),
        width: '20px',
        height: '20px',
      },
      alertText: {
        color: getTextColor(),
        marginTop: theme.sizeGuide.none,
      },
    }),
    [getBgColor, getBorderColor, getIconColor, getTextColor, theme, tokens],
  );

  return styles;
};

export default useAssetronAlertStyles;
